import { useContext } from "react";
import { SearchBoxContext } from "../SearchBoxContext/index.js";
const useSubmit = () => {
    const { i18n, trackV2, doSearch, isHeaderUpdateExp, isResponsiveFixes, searchType, allowEmptyDestination, segments, isMobile } = useContext(SearchBoxContext);
    const isMultiStop = searchType === "MULTISTOP";
    const isDestinationEmpty = segments.every((segment) => segment.to.length === 0);
    return {
        i18n,
        trackV2,
        doSearch,
        isHeaderUpdateExp,
        isResponsiveFixes,
        isMultiStop,
        allowEmptyDestination,
        isDestinationEmpty,
        isMobile
    };
};
export default useSubmit;
